import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Components/Home";
import Oops from "./Components/Oops";
import Carte from "./Components/Carte";

function App() {

 

  return (
    <Router>
      <Routes>


        {/* PUBLIC */}
        <Route path="/" element={<Home />} />
        <Route path="/carte" element={<Carte />} />
        <Route path="*" element={<Oops />} />
       
      </Routes>
    </Router>
  );
}

export default App;
